<template>
  <el-form
    class="start-timer"
    ref="startTimerForm"
    :model="formData"
    :rules="rules"
    label-position="left"
    v-loading="starting"
  >
    <el-card>
      <div slot="header">Timer (Stopped)</div>

      <el-form-item>
        <el-button class="full-width" type="success" @click="handleTimerStart"><i class="fas fa-play"></i>  START TIMER</el-button>
      </el-form-item>

      <div slot="footer">
        <el-row :gutter="0" type="flex" justify="space-between">
          <el-col :span="8">
            <el-form-item label="Category" prop="category_id">
              <el-select v-model.lazy.trim="formData.category_id" placeholder="Select category">
                <el-option
                  v-for="(category, index) in categories"
                  :key="index"
                  :label="category.name"
                  :value="category.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="Note" prop="note">
              <el-input type="textarea" v-model.lazy="formData.note" placeholder="Note"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-form>
</template>

<script>
  import moment from 'moment';
  import { mapActions, mapGetters } from 'vuex';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'StartTimer',
    props: {
      startTimeLimit: {
        type: [Object, String],
      },
    },
    mounted() {
      this.fetchCategories({ scope: 'active', type: 'BillingCategory' });
    },
    data() {
      return {
        today: moment(),
        formData: {
          category_id: '',
          note: '',
          started_at: '',
        },
        rules: {
          category_id: [
            { type: 'integer', required: true, message: 'Please provide category', trigger: 'blur' },
          ],
          started_at: [
            { validator: this.validateStartedAt, trigger: 'blur' },
          ],
        },
      };
    },
    computed: {
      ...mapGetters('entities/timeLogs', ['starting']),
      ...mapGetters('entities/users', ['currentUser']),
      categories() {
        return this.$store.getters['entities/categories/query']().where(category => category.name !== 'General').get();
      },
    },
    methods: {
      ...mapActions('entities/timeLogs', ['startTimer']),
      ...mapActions('entities/categories', ['fetchCategories']),

      handleTimerStart() {
        this.$refs.startTimerForm.validate((valid) => {
          if (valid) {
            this.startTimer(this.formData)
              .then((response) => {
                if (response.status) {
                  this.clockInOut(this.currentUser.profile.full_name, 'IN');
                } else {
                  showErrorMessage(response.error);
                }
              });
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
      validateStartedAt(rule, value, callback) {
        const startTimeLimit = this.startTimeLimit ? moment(this.startTimeLimit) : moment().startOf('day');

        if (value !== '') {
          if (moment(value).isBefore(startTimeLimit)) {
            callback(new Error(`You cannot start time log with time before ${startTimeLimit.format('LTS')}`));
          } else if (moment(value).isAfter(moment())) {
            callback(new Error('You cannot set start time in the future'));
          }
        }

        callback();
      },

      async clockInOut(username, clockstatus) {
        let statusCode;
        let result;
        const formdata = new FormData();
        const msg = `User: ${username} Clock: ${clockstatus}`;

        formdata.append('message', msg);

        const params = new URLSearchParams({
          name: username,
          clock: clockstatus,
        });

        const url = `https://bvapmiult0.execute-api.us-east-1.amazonaws.com/send_message?${params}`;

        const requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow',
        };

        try {
          const response = await fetch(url, requestOptions);
          if (response.ok) {
            await response.json();
            showSuccessMessage('You have been clocked in successfully.');
          }
        } catch (error) {
          result = error;
          statusCode = 400;
          console.error('Error:', error);
        }

        const resp = { status: statusCode, body: JSON.stringify(result) };

        return resp;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .start-timer{
    .full-width{
      font-size: 20px;
      padding: 20px;
      i{
        margin-right: 10px;
      }
    }
    .el-form-item{
      margin-bottom: 0;
    }
    .el-collapse{
      margin: -20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TimerStart.vue